<template>
  <div id="attachFilesComponent">
    <page-title v-if="!$attrs.item" :heading=heading :icon=icon></page-title>
    <v-container v-if="loadItem">
      <v-layout>
        <v-flex>
          <v-btn @click="$router.back()" color="primary" outline round><v-icon left>undo</v-icon>{{$t('general.back')}}</v-btn>
        </v-flex>
      </v-layout>
      <v-card flat>
        <v-card-text class="text-center">
          <v-progress-circular color="primary" size="50" indeterminate/>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container v-if="!loadItem">
      <template v-if="!$attrs.item">
        <v-layout>
          <v-flex>
            <v-btn @click="$router.back()" color="primary" outline round><v-icon left>undo</v-icon>{{$t('general.back')}}</v-btn>
          </v-flex>
        </v-layout>
        <v-card flat>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs2>
                <h3>
                  <span class="primary--text font-weight-black">
                    {{$t('expenseItems.name')}}:
                  </span>
                  #{{editedItem.id}}
                </h3>
              </v-flex>
              <v-flex xs7>
                <h3>
                  <span class="primary--text font-weight-black">
                    {{$t('general.description')}}:
                  </span>
                  {{editedItem.description}}
                </h3>
              </v-flex>
              <v-flex xs3>
                <h3>
                  <span class="primary--text font-weight-black">
                    {{$t('general.category')}}:
                  </span>
                  {{editedItem.gst_categories ? editedItem.gst_categories.name : ''}}
                </h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-layout>
          <v-divider/>
        </v-layout>
      </template>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="primary--text font-weight-black">{{$t('expenses.files')}}:</h3>
        </v-flex>
        <v-flex v-if="editedItem.file_attach.length > 0">
          <v-btn
            v-for="file in editedItem.file_attach"
            :key="file.id"
            color="primary"
            dark
            @click="watchFile(file)"
          >
            <v-icon left v-if="file.files_type_id === 9 || file.files_type_id === 12">fas fa-file-archive</v-icon>
            <v-icon left v-else-if="file.files_type_id === 3">description</v-icon>
            <v-icon left v-else>insert_photo</v-icon>
            <h3 class="pb-0 mb-0">{{$t('expenses.file')}} {{file.id}}</h3>
          </v-btn>
        </v-flex>
        <v-flex v-else>
          <v-alert color="info" outline :value="true" icon="info">
            {{$t('expenses.noFiles')}}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout v-if="$route.params.action === 'attach'" wrap>
        <v-flex xs12>
          <v-divider/>
          <h3 class="primary--text font-weight-black">Cargar archivos:</h3>
          <vue-dropzone
            ref="dropzone"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-processing="fileAdded"
            v-on:vdropzone-error="fileUploadError"
            v-on:vdropzone-success="fileUpload"
            v-on:vdropzone-removed-file="removeFile"
            >
          </vue-dropzone>
        </v-flex>
      </v-layout>
      <v-layout v-if="$route.params.action === 'attach'" row>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="attachItems()"
          :loading="loading"
          :disabled="loading || uploadedFiles.length === 0"
        >{{$t('general.save')}}</v-btn>
      </v-layout>
    </v-container>
    <v-dialog
      persistent
      v-model="dialog"
      scrollable
      max-width="900px">
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.file') + ': ' + watchItem.id}}</h2>
        </v-toolbar>
        <v-card-text class="text-center">
          <div class="d-flex align-center">
            <h2 class="text-sm-left primary--text mb-0">
              {{ $t('expenses.fileType') + ': ' + fileWatchType }}
            </h2>
            <p v-if="watchItem.files_type_id === 3" class="text-sm-left mb-0">
              ({{ $t('file.errorViewDownload') }})
            </p>
            <v-btn v-if="watchItem.files_type_id === 3" @click="downloadAccuse(watchItem)" color="primary" class="white--text" :disabled="loadingDownload" round small >
              <v-icon right dark>mdi-download-multiple</v-icon>
            </v-btn>
          </div>
          <iframe
            v-if="watchItem.files_type_id === 3 && dataURL"
            :src="dataURL"
            frameborder="0"
            width="100%" height="400px"
          />
          <zoom-on-hover
            v-if="dataURL && watchItem.files_type_id !== 3"
            :img-normal="dataURL"
          />
          <v-btn
            color="primary"
            @click="downloadFile()"
            :loading="loadBtn"
            :disabled="loadBtn"
            v-if="(watchItem.files_type_id === 9 || watchItem.files_type_id === 12) && !loadFile"
          >volver a descargar</v-btn>
          <v-progress-circular
            v-if="!dataURL && loadFile"
            color="primary"
            size="50"
            indeterminate
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error darken-1"
            round
            flat
            @click="close"
          >
            {{ $t('general.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
export default {
  name: 'attachFilesComponent',
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      editedItem: {
        id: '',
        description: '',
        gst_categories: {
          name: ''
        },
        file_attach: []
      },
      loading: false,
      loadFile: false,
      loadBtn: false,
      loadItem: true,
      dialog: false,
      uploadedFiles: [],
      arrayFiles: [],
      dataURL: null,
      watchItem: {
        files_type_id: 0
      },
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf,.zip',
        // maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'user_id': this.$store.state.userLogged.id,
          'dirname': 'ATTACHMENT_EXPENSES'
        },
      },
      loadingDownload: false,
    }
  },
  computed: {
    heading () {
      return this.$route.params.action === 'attach' ? this.$t('expenses.attach') : this.$t('expenses.attachedFiles')
    },
    icon () {
      return 'fas fa-paperclip fa-fw icon-color'
    },
    fileWatchType () {
      if (this.watchItem.files_type_id) {
        switch (this.watchItem.files_type_id) {
          case 3:
            return 'pdf'
          case 9:
            return 'rar'
          case 12:
            return 'zip'
          case 5:
            return 'jpeg'
          case 6:
            return 'png'
          default:
            return 'img'
        }
      }
    }
  },
  created () {
    this.getItem()
  },
  methods: {
    downloadAccuse(item) {
      this.loadingDownload = true
      this.$store.dispatch('downloadFile', { event: { context: this, fileId: item.id } })
    },
    fileAdded (file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      switch (fileType) {
        case 'image/jpeg':
          this.dropzoneOptions.params.files_type_id = 5
          break
        case 'image/png':
          this.dropzoneOptions.params.files_type_id = 6
          break
        case 'application/pdf':
          this.dropzoneOptions.params.files_type_id = 3
          break
        case 'application/zip':
        case 'application/x-zip-compressed':
          this.dropzoneOptions.params.files_type_id = 12
          break
        case 'application/rar':
          this.dropzoneOptions.params.files_type_id = 9
          break
        default:
          this.dropzoneOptions.params.files_type_id = null
          break
      }
    },
    fileUploadError (file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
    //   this.$refs.dropzoneXML = message.errors.path[0]
    },
    fileUpload (file, response) {
      this.uploadedFiles.push(response.data.id)
      this.arrayFiles = this.$refs.dropzone.getAcceptedFiles()
    },
    removeFile (file, error, xhr) {
      let index = this.arrayFiles.indexOf(file)
      this.arrayFiles.splice(index, 1)
      this.uploadedFiles.splice(index, 1)
    },
    attachItems () {
      this.loading = true
      this.$emit('attachItems', {items: this.uploadedFiles, id: this.editedItem.id, context: this})
    },
    watchFile (item) {
      this.dialog = true
      this.watchItem = item
      this.loadFile = true
      if (item.files_type_id === 9 || item.files_type_id === 12) {
        this.$store.dispatch('getZip', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      } else {
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      }
    },
    downloadFile () {
      this.loadBtn = true
      this.$store.dispatch('getZip', {
        event: {
          context: this,
          fileId: this.watchItem.id
        }
      })
    },
    getItem () {
      this.$emit('getItem', {id: this.$route.params.id, context: this})
      if (this.$attrs.item) {
        this.$store.dispatch('expensesItems/getItem', {event: {id: this.$attrs.item.id, context: this}})
      }
    },
    close () {
      this.dialog = false
      this.loadFile = false
      this.dataURL = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/attachFiles.component.vue